module.exports = __webpack_public_path__ + "static/media/16@1280w.8f068b83.jpg";